import React, { useState, useEffect, useRef } from 'react';

import axios, { AxiosError } from '../Axiosinstance'
// import { logoImage } from '../common';
import { Link, useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import logopng from '.././images/logopng.png'
import {
  faHome,
  faBook,
  faCalendar,
  faGraduationCap,
  faCog,
  faQuestionCircle,
  faFolder,
  faUser,
  faLayerGroup,
  faDesktop,
  faSignOutAlt,
  faChevronDown,
  faAddressBook,
  faPersonBooth,
  faPersonCircleMinus,
  faPerson,
  faBookOpenReader,
  faFolderOpen
} from "@fortawesome/free-solid-svg-icons";
import 'bootstrap/dist/css/bootstrap.min.css';
import './Header.css';
import { Modal, Button } from 'react-bootstrap';
import { FaAmazonPay, FaPaypal } from 'react-icons/fa';
import { Divider } from '@mui/material';
import { encryptData, decryptData } from '../Axiosinstance';

function App() {
  const [isResourcesOpen, setResourcesOpen] = useState(false);
  const [isHelpOpen, setHelpOpen] = useState(false);
  const [isAccountOpen, setAccountOpen] = useState(false);
  const [isNavOpen, setNavOpen] = useState(false);
  const [showModal, setShowModal] = useState(false);

  const dropdownRef = useRef(null);
  const openModal = () => {
    setShowModal(true);
  };

  // Function to handle closing the modal
  const closeModal = () => {
    setShowModal(false);
  };

  const toggleResources = (e) => {
    console.log("lalchand", e);
    setResourcesOpen(!isResourcesOpen);
    setHelpOpen(false);
    setAccountOpen(false);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setResourcesOpen(false);
        setHelpOpen(false);
        setAccountOpen(false);
      }
    };

    // Add event listener
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      // Cleanup event listener
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);


  const toggleHelp = (e) => {
    e.preventDefault();
    setHelpOpen(!isHelpOpen);
    setAccountOpen(false); // Close other dropdowns
  };

  // Function to toggle Account dropdown
  const toggleAccount = (e) => {
    e.preventDefault();
    setAccountOpen(!isAccountOpen);
    setHelpOpen(false); // Close other dropdowns
  };





  const [isHamburgerActive, setHamburgerActive] = useState(false);
  const [isNavActive, setNavActive] = useState(false);
  const navigate = useNavigate();
  const [studentName, setStudentName] = useState(null);
  const [profileUrl, setProfileUrl] = useState(null);
  const handleLogout = () => {
    // Remove user data from local storage
    localStorage.removeItem("loggedInUserId");
    localStorage.removeItem("usertype");
    localStorage.removeItem("studentteacherid");
    localStorage.removeItem('jwtToken');
    localStorage.removeItem('userId');
    localStorage.removeItem('username');

    document.title = "LMS-impluz";

    // Navigate to the login page
    // navigate("/");

    openModal();
  };



  useEffect(() => {
    const userId = decryptData(localStorage.getItem("userId"));

    if (userId) {
      axios.get(`home/user/${userId}`)
        .then((response) => {
          if (response.status === 200) {
            // alert(response.status);
            const data = response.data;
            localStorage.setItem("studentteacherid", encryptData(data.sfid));
            document.title = `impluz - ${data.name}`;
            setStudentName(data.name);
            setProfileUrl(data.profile_Url);
          }

          else {
            throw new Error("Failed to fetch sfid");
          }
        })
        .catch((error) => {
          console.error(error.response);
          if (error == "AxiosError: Network Error")
            handleLogout()
          // alert(error)
          // Handle any errors that occur during the API call
        });
    }
  }, []);


  const toggleHamburger = () => {
    setHamburgerActive((prevState) => !prevState);
    setNavActive((prevState) => !prevState);
  };

  const toggleNav = () => {
    console.log('Toggling navigation menu');
    setNavOpen(!isNavOpen);
  };


  return (
    <div className={`App ${isNavOpen ? 'opened' : ''}`} style={{ marginBottom: '1%' }}>
      <nav>
        <div className="logo">
          <Link to='/adhome'>
            <img
              id='imglogo'
              src={logopng}
              alt="logoImage"

            /> </Link>       </div>
        <button className={`btn-hamburger ${isNavOpen ? 'opened' : ''}`} onClick={toggleNav}>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
        </button>




        <ul className={`nav-menu ${isNavOpen ? 'opened' : ''}`}  >
          <li className="nav-item" style={{ fontFamily: '' }}><Link to="/Adhome"><FontAwesomeIcon icon={faHome} /> Home </Link></li>
          <li className="nav-item"><Link to="/Batches"> <FontAwesomeIcon icon={faLayerGroup} /> Course Run </Link></li>
          {/* <li className="nav-item"><Link to="/Batch"><FontAwesomeIcon icon={faCalendar} />  Schedule </Link></li> */}
          <li className="nav-item"><Link to="/Allstudent"><FontAwesomeIcon icon={faGraduationCap} />  Students </Link></li>

          <li
            ref={dropdownRef}
            style={{ color: "black", marginRight: "-2%" }}
            className={`nav-item dropdown ${isResourcesOpen ? "show" : ""}`}
          >
            <a href="#" onClick={toggleResources}>
              <FontAwesomeIcon icon={faFolderOpen} /> Resources
            </a>

            {isResourcesOpen && (
              <div className="dropdown-menu show">
                <Link className="dropdown-item" to="/CourseCatagories">
                  <FontAwesomeIcon icon={faFolder} style={{ marginRight: "8px" }} /> Course Categories
                </Link>
                <Link className="dropdown-item" to="/Allcourse">
                  <FontAwesomeIcon icon={faBook} style={{ marginRight: "8px" }} /> Course
                </Link>
                <Link className="dropdown-item" to="/Alumistudent">
                  <FontAwesomeIcon icon={faUser} style={{ marginRight: "8px" }} /> Alumni Student
                </Link>
                <Link className="dropdown-item" to="/Facilitor">
                  <FontAwesomeIcon icon={faBookOpenReader} style={{ marginRight: "8px" }} /> Facilitators
                </Link>
                <Link className="dropdown-item" to="/coursefee">
                  <FontAwesomeIcon icon={faAddressBook} style={{ marginRight: "8px" }} /> Payments
                </Link>
                <Link className="dropdown-item" to="/Totalpay">
                  <FontAwesomeIcon icon={faPersonBooth} style={{ marginRight: "8px" }} /> Pay Log
                </Link>
              </div>
            )}
          </li>
          {/* style={{ marginRight: '-3%'}} */}

          {/* <li className="nav-item" >
            <Link to='/Setting' >  <FontAwesomeIcon icon={faCog} /> Settings</Link></li> */}




          {/* <li style={{ color: 'black' }} className={`nav-item dropdown ${isHelpOpen ? 'show' : ''}`}>
            <a to={''} onClick={toggleHelp}> <FontAwesomeIcon icon={faQuestionCircle} /> Help <FontAwesomeIcon /></a>
            <div className={`dropdown-menu ${isHelpOpen ? 'show' : ''}`}>
              <Link className="dropdown-item" to='/Chat' >Contact us</Link>
              {/* <a className="dropdown-item" to={''}>Live Chat</a> */}
          {/* <a className="dropdown-item" to={''}>Remote Desktop</a> */}
          {/* </div> */}
          {/* </li>  */}

          <li style={{ color: 'black', marginRight: '-2%' }} className={`nav-item dropdown ${isHelpOpen ? 'show' : ''}`}>
            <a to={''} onClick={toggleHelp}> <FontAwesomeIcon icon={faQuestionCircle} /> Help <FontAwesomeIcon /></a>
            <div className={`dropdown-menu ${isHelpOpen ? 'show' : ''}`}>
              <Link className="dropdown-item" to='/Chat' >Contact us</Link>
              {/* <a className="dropdown-item" to={''}>Live Chat</a> */}
              {/* <a className="dropdown-item" to={''}>Remote Desktop</a> */}
            </div>
          </li>


          <span style={{ width: '40px' }}>
            <li className={`nav-item dropdown ${isAccountOpen ? 'show' : ''}`}>
              <a to={''} onClick={toggleAccount}>
                {profileUrl ? (
                  <img
                    src={profileUrl}
                    alt="Profile"
                    style={{ marginLeft: '5px', borderRadius: '50%', width: '50px', height: '50px' }}
                  />
                ) : (
                  <span
                    style={{
                      marginLeft: '5px',
                      borderRadius: '50%',
                      width: '50px',
                      height: '50px',
                      backgroundColor: 'gray',
                    }}
                  ></span>
                )}
                {studentName ? (

                  studentName
                ) : (
                  <span className="placeholder-text" >Loading</span>
                )}{' '}
                <FontAwesomeIcon />
              </a>

              <div className={`dropdown-menu ${isAccountOpen ? 'show' : ''}`}>
                <Link className="dropdown-item" to="/Profile">
                  Profile
                </Link>
                <a onClick={handleLogout} className="dropdown-item" to={'/'}>
                  Log out <FontAwesomeIcon icon={faSignOutAlt} style={{ marginLeft: '8px' }} />
                </a>

              </div>
            </li>
          </span>


        </ul>
      </nav>
      <div className="container">

      </div>

      <Modal show={showModal} onHide={closeModal} backdrop="static" centered>
        <Modal.Body>
          <p>Your session has been closed.</p>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" style={{ backgroundColor: '#007bff' }} onClick={() => { navigate("/login") }}>
            Okay
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}

export default App;




